export default __webpack_public_path__ + "curve3.png";